import { render } from "./VideoWrapper.vue?vue&type=template&id=0818b64e"
import script from "./VideoWrapper.vue?vue&type=script&lang=js"
export * from "./VideoWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__